import React from "react";
import { CardTitle } from "reactstrap";
import { Icon, TooltipComponent } from "../../../Component";
import { BarChart } from "../../charts/sales/Charts";

const AvgSubscription = ({ data, chart, title, tooltipText }) => {
  return (
    <React.Fragment>
      {" "}
      <div className="card-title-group align-start mb-2">
        <CardTitle>
          <h6 className="title">{title ?? "Rolling sign-ups"}</h6>
        </CardTitle>
        <div className="card-tools">
          <TooltipComponent
            icon="help-fill"
            iconClass="card-hint"
            direction="left"
            id="Tooltip-3"
            text={tooltipText ?? "New users per month over the last six months"}
          />
        </div>
      </div>
      <div className="align-end flex-sm-wrap g-4 flex-md-nowrap">
        <div className="nk-sale-data">
          <span className="amount">{data[0]?.count}</span>
          <span className="sub-title">
            <span className="change up text-success">
              <Icon name="arrow-long-up" />
              {data[0]?.precent}
            </span>
           {data[0]?.title}
          </span>
        </div>
        <div className="nk-sales-ck">
          <BarChart data={chart} />
        </div>
      </div>
    </React.Fragment>
  );
};
export default AvgSubscription;
